import { ReactElement } from 'react';
import { Link } from '@backstage/core-components';
import { makeStyles, Typography } from '@material-ui/core';
import AppsIcon from '@material-ui/icons/Apps';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import ViewListIcon from '@material-ui/icons/ViewList';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import logo from '../../assets/logo-vanti.png';
import { VANTI } from '../theme';

const useStyles = makeStyles(theme => ({
  logo: { height: 52, width: 'auto', display: 'block', marginBottom: 12 },
  intro: { color: theme.palette.text.secondary, marginBottom: 20 },
  modulos: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: 16,
  },
  modulo: {
    display: 'flex',
    gap: 14,
    alignItems: 'flex-start',
    padding: 16,
    borderRadius: 12,
    background: theme.palette.type === 'dark' ? 'transparent' : VANTI.panel,
    border: `1px solid ${theme.palette.divider}`,
    textDecoration: 'none !important',
    transition: 'border-color .15s, transform .15s',
    '&:hover': { borderColor: VANTI.gold, transform: 'translateY(-2px)' },
  },
  // Ícono en círculo outline navy con detalle dorado (identidad Vanti)
  circulo: {
    position: 'relative',
    flex: '0 0 44px',
    height: 44,
    borderRadius: '50%',
    border: `2px solid ${
      theme.palette.type === 'dark' ? VANTI.gold : VANTI.navy
    }`,
    display: 'grid',
    placeItems: 'center',
    color: theme.palette.type === 'dark' ? VANTI.gold : VANTI.navy,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: -2,
      right: -2,
      width: 12,
      height: 12,
      borderRadius: '50%',
      background: VANTI.gold,
    },
  },
  titulo: { fontWeight: 800, color: theme.palette.text.primary },
  desc: { color: theme.palette.text.secondary, fontSize: 13 },
}));

type Modulo = {
  to: string;
  titulo: string;
  desc: string;
  icono: ReactElement;
};

const MODULOS: Modulo[] = [
  {
    to: '/hoja-de-vida',
    titulo: 'Hoja de vida',
    desc: 'Responsables, riesgo, seguridad y ficha técnica de cada aplicación.',
    icono: <AppsIcon />,
  },
  {
    to: '/integraciones',
    titulo: 'Integraciones',
    desc: 'Qué aplicación consume qué interfaz de cuál otra, y cómo.',
    icono: <DeviceHubIcon />,
  },
  {
    to: '/catalogo-servicios',
    titulo: 'Catálogo de servicios',
    desc: 'Componentes desplegados y las APIs que exponen.',
    icono: <ViewListIcon />,
  },
  {
    to: '/catalog',
    titulo: 'Catálogo completo',
    desc: 'Todas las entidades y su grafo de relaciones.',
    icono: <AccountTreeIcon />,
  },
];

export const Bienvenida = () => {
  const classes = useStyles();
  return (
    <div>
      <img className={classes.logo} src={logo} alt="Vanti" />
      <Typography className={classes.intro}>
        Vanti Arch es el portal de arquitectura de Grupo Vanti: el inventario de
        aplicaciones, sus servicios y cómo se integran entre sí.
      </Typography>
      <div className={classes.modulos}>
        {MODULOS.map(m => (
          <Link key={m.to} to={m.to} className={classes.modulo}>
            <span className={classes.circulo}>{m.icono}</span>
            <span>
              <Typography className={classes.titulo}>{m.titulo}</Typography>
              <Typography className={classes.desc}>{m.desc}</Typography>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};
